import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { SessionQuery } from '@core/session/store/session.query';

const SURGERY_WORK_QUEUE_URL = '/main/anesthesia/surgery-work-queue';

@Injectable({ providedIn: 'root' })
export class ViewOnlyLockdownGuard {
  private sessionQuery = inject(SessionQuery);
  private router = inject(Router);

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.sessionQuery.user$.pipe(
      filter((user) => user != null),
      take(1),
      map((user) => {
        if (user.isAdministrator) return true;
        if (!user.claims?.includes('app:surgery-work-queue:view-only')) return true;
        if (state.url.startsWith(SURGERY_WORK_QUEUE_URL)) return true;
        return this.router.parseUrl(SURGERY_WORK_QUEUE_URL);
      }),
    );
  }
}
